import React from 'react';
import { Container, Form } from '../common';

const Sidebar = ({ sanity }) => (
  <aside className="relative h-full">
    <div className="sticky top-48">
      <Container padding="none">
        <Form sanity={sanity} formName="form-sidebar" />
      </Container>
    </div>
  </aside>
);

export { Sidebar };
